var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "460" },
              model: {
                value: _vm.show,
                callback: function ($$v) {
                  _vm.show = $$v
                },
                expression: "show",
              },
            },
            [
              _c(
                "v-form",
                {
                  ref: "formRef",
                  attrs: { name: "form" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.onSaveClick.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "v-stepper",
                    {
                      attrs: { "non-linear": "" },
                      model: {
                        value: _vm.e1,
                        callback: function ($$v) {
                          _vm.e1 = $$v
                        },
                        expression: "e1",
                      },
                    },
                    [
                      _c(
                        "v-stepper-header",
                        [
                          _c("v-stepper-step", {
                            attrs: {
                              color: "secondary",
                              complete: _vm.e1 > 1,
                              step: "1",
                              editable: _vm.checkPassword(),
                            },
                          }),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c("v-stepper-step", {
                            attrs: {
                              color: "secondary",
                              complete: _vm.e1 > 2,
                              step: "2",
                              editable: _vm.checkPassword(),
                            },
                          }),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c("v-stepper-step", {
                            attrs: {
                              color: "secondary",
                              complete: _vm.e1 > 3,
                              step: "3",
                              editable: _vm.checkPassword(),
                            },
                          }),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c("v-stepper-step", {
                            attrs: {
                              color: "secondary",
                              complete: _vm.e1 > 4,
                              step: "4",
                              editable: _vm.checkPassword(),
                            },
                          }),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c("v-stepper-step", {
                            attrs: {
                              color: "secondary",
                              complete: _vm.e1 > 5,
                              step: "5",
                              editable: _vm.checkPassword(),
                            },
                          }),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c("v-stepper-step", {
                            attrs: {
                              color: "secondary",
                              complete: _vm.e1 > 6,
                              step: "6",
                              editable: _vm.checkPassword(),
                            },
                          }),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c("v-stepper-step", {
                            attrs: {
                              color: "secondary",
                              complete: _vm.e1 > 7,
                              step: "7",
                              editable: _vm.checkPassword(),
                            },
                          }),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c("v-stepper-step", {
                            attrs: {
                              color: "secondary",
                              complete: _vm.e1 > 8,
                              step: "8",
                              editable: _vm.checkPassword(),
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-stepper-items",
                        [
                          _c(
                            "v-stepper-content",
                            {
                              attrs: {
                                step: "1",
                                editable: _vm.checkPassword(),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "mb-8" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "header-font",
                                      staticStyle: { "font-size": "22px" },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("login.password"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "body-1" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("login.firstLoginMessage"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "body-1 font-weight-bold primary--text pb-1 mb-0",
                                    },
                                    [_vm._v(_vm._s(_vm.$t("login.password")))]
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    ref: "passwordRef",
                                    staticClass: "pa-0",
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      rules: _vm.passwordRules,
                                      type: "password",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onInputChange()
                                      },
                                    },
                                    model: {
                                      value: _vm.user.password,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.user, "password", $$v)
                                      },
                                      expression: "user.password",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "body-1 font-weight-bold primary--text pb-1 mb-0",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("login.passwordConfirmation")
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    ref: "passwordConfirmationRef",
                                    staticClass: "pa-0",
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      rules: _vm.passwordConfirmationRules,
                                      type: "password",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onInputChange()
                                      },
                                    },
                                    model: {
                                      value: _vm.user.passwordConfirmation,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.user,
                                          "passwordConfirmation",
                                          $$v
                                        )
                                      },
                                      expression: "user.passwordConfirmation",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font px-4 me-2",
                                  attrs: {
                                    color: _vm.$vuetify.theme.dark
                                      ? "white"
                                      : "secondary darken-1",
                                    rounded: "",
                                    outlined: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onCancelClick()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("general.cancel")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font white--text px-4 me-2",
                                  attrs: {
                                    rounded: "",
                                    color: "primary",
                                    disabled: !_vm.checkPassword(),
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.e1 = 2
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("tours.buttons.next")))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-stepper-content",
                            {
                              attrs: {
                                step: "2",
                                editable: _vm.checkPassword(),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "mb-12" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "body-1 font-weight-bold primary--text pb-1 mb-0",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("settings.language"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      items: _vm.languages,
                                      "item-text": "name",
                                      "item-value": "id",
                                      "menu-props": "auto",
                                      "hide-details": "",
                                      rules: _vm.languageRules,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.changeLocale(
                                          _vm.user.languageId
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.user.languageId,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.user, "languageId", $$v)
                                      },
                                      expression: "user.languageId",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font px-4 me-2",
                                  attrs: {
                                    color: _vm.$vuetify.theme.dark
                                      ? "white"
                                      : "secondary darken-1",
                                    rounded: "",
                                    outlined: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onSaveClick()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("login.skipSettings")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font white--text px-4 me-2",
                                  attrs: { rounded: "", color: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.e1 = 3
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("tours.buttons.next")))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-stepper-content",
                            {
                              attrs: {
                                step: "3",
                                editable: _vm.checkPassword(),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "mb-8" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "pa-0 my-2 header-font",
                                      staticStyle: { "font-size": "22px" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "settings.defaultPlayerVisualization"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-radio-group",
                                    {
                                      staticClass:
                                        "mt-2 d-flex justify-space-between default-player-visualization-radio",
                                      attrs: {
                                        dense: "",
                                        "hide-details": "",
                                        row: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onDefaultVisualizationChange(
                                            $event
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.defaultVisualizationModel,
                                        callback: function ($$v) {
                                          _vm.defaultVisualizationModel = $$v
                                        },
                                        expression: "defaultVisualizationModel",
                                      },
                                    },
                                    [
                                      _c("v-radio", {
                                        staticClass: "mt-1",
                                        attrs: {
                                          color: "secondary",
                                          label: _vm.$t(
                                            "playerRecruitment.radar"
                                          ),
                                          value: "radar",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-1 primary--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "playerRecruitment.radar"
                                                          )
                                                        ) +
                                                          "\n                      "
                                                      ),
                                                      _c(
                                                        "sup",
                                                        [
                                                          _c(
                                                            "v-chip",
                                                            {
                                                              staticClass:
                                                                "p-0",
                                                              attrs: {
                                                                color: "orange",
                                                                "text-color":
                                                                  "white",
                                                                pill: "",
                                                                "x-small": "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "settings.recommended"
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          1204420220
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("v-radio", {
                                        staticClass: "mt-1",
                                        attrs: {
                                          color: "secondary",
                                          label: _vm.$t(
                                            "playerRecruitment.lollipop"
                                          ),
                                          value: "lollipop",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-1 primary--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "playerRecruitment.lollipop"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          2776579555
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("v-radio", {
                                        staticClass: "mt-1",
                                        attrs: {
                                          color: "secondary",
                                          label: _vm.$t(
                                            "playerRecruitment.polar"
                                          ),
                                          value: "polar",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-1 primary--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "playerRecruitment.polar"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          805402118
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-row justify-space-around mt-5",
                                    },
                                    [
                                      _c("v-img", {
                                        attrs: {
                                          src: require(`@/assets/img/visualization_${_vm.defaultVisualizationModel}.png`),
                                          height: "200",
                                          contain: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font px-4 me-2",
                                  attrs: {
                                    color: _vm.$vuetify.theme.dark
                                      ? "white"
                                      : "secondary darken-1",
                                    rounded: "",
                                    outlined: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onSaveClick()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("login.skipSettings")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font white--text px-4 me-2",
                                  attrs: { rounded: "", color: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.e1 = 4
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("tours.buttons.next")))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-stepper-content",
                            {
                              attrs: {
                                step: "4",
                                editable: _vm.checkPassword(),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "mb-12" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "pa-0 my-2 header-font",
                                      staticStyle: { "font-size": "22px" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("settings.fieldColor"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-radio-group",
                                    {
                                      staticClass:
                                        "mt-2 d-flex justify-space-between",
                                      attrs: {
                                        dense: "",
                                        "hide-details": "",
                                        row: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onFieldColorChange($event)
                                        },
                                      },
                                      model: {
                                        value: _vm.fieldColorModel,
                                        callback: function ($$v) {
                                          _vm.fieldColorModel = $$v
                                        },
                                        expression: "fieldColorModel",
                                      },
                                    },
                                    _vm._l(
                                      _vm.fieldColors,
                                      function (fieldColor) {
                                        return _c("v-radio", {
                                          key: fieldColor,
                                          staticClass: "mt-1",
                                          attrs: {
                                            color: "secondary",
                                            label: fieldColor,
                                            value: fieldColor,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              `settings.fieldColors.${fieldColor}`
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-row justify-space-around mt-5",
                                    },
                                    [
                                      _c("v-img", {
                                        staticClass: "me-2",
                                        attrs: {
                                          src: require(`@/assets/img/half_pitch_${_vm.fieldColorModel}.png`),
                                          "max-width": "160",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("v-img", {
                                        staticClass: "ms-2",
                                        attrs: {
                                          src: require(`@/assets/img/pitch_${_vm.fieldColorModel}.png`),
                                          "max-width": "160",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font px-4 me-2",
                                  attrs: {
                                    color: _vm.$vuetify.theme.dark
                                      ? "white"
                                      : "secondary darken-1",
                                    rounded: "",
                                    outlined: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onSaveClick()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("login.skipSettings")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font white--text px-4 me-2",
                                  attrs: { rounded: "", color: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.e1 = 5
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("tours.buttons.next")))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-stepper-content",
                            {
                              attrs: {
                                step: "5",
                                editable: _vm.checkPassword(),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "mb-12" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "pa-0 my-2 header-font",
                                      staticStyle: { "font-size": "22px" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "faq.categories.playerPositions"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-radio-group",
                                    {
                                      staticClass:
                                        "mt-2 d-flex justify-space-between",
                                      attrs: {
                                        dense: "",
                                        "hide-details": "",
                                        row: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onFieldPositionChange(
                                            $event
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.fieldPositionModel,
                                        callback: function ($$v) {
                                          _vm.fieldPositionModel = $$v
                                        },
                                        expression: "fieldPositionModel",
                                      },
                                    },
                                    _vm._l(
                                      _vm.fieldPositionOptions,
                                      function (fieldPositionOption) {
                                        return _c("v-radio", {
                                          key: fieldPositionOption.id,
                                          staticClass: "mt-1",
                                          attrs: {
                                            color: "secondary",
                                            label: fieldPositionOption.code,
                                            value: fieldPositionOption.id,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              `settings.fieldPositions.${fieldPositionOption.code}`
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass:
                                        "alig-center justify-center mt-4",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          ref: "pitch",
                                          staticClass:
                                            "d-flex align-center w-100 h-80",
                                        },
                                        [
                                          _c(
                                            "v-img",
                                            {
                                              staticClass: "rounded",
                                              attrs: {
                                                src: require(`@/assets/img/pitch_${_vm.fieldColorModel}.png`),
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "position_field d-flex flex-wrap h-100 justify-space-between align-center",
                                                },
                                                _vm._l(
                                                  _vm.fieldPositions,
                                                  function (position, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index,
                                                        staticClass:
                                                          "w-16 h-32 d-flex justify-center",
                                                        class: {
                                                          caja: position,
                                                        },
                                                        style: {
                                                          "background-color": `rgba(0,0,255,${
                                                            position.length ===
                                                            0
                                                              ? 0
                                                              : 0.195
                                                          }`,
                                                        },
                                                      },
                                                      [
                                                        position
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex justify-center align-center w-100",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-chip",
                                                                  {
                                                                    staticClass:
                                                                      "monospace-font",
                                                                    staticStyle:
                                                                      {
                                                                        height:
                                                                          "25px",
                                                                      },
                                                                    attrs: {
                                                                      color:
                                                                        _vm.getPositionChip(
                                                                          position
                                                                        ),
                                                                      "text-color":
                                                                        "white",
                                                                      small: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.getPositionCode(
                                                                          position
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font px-4 me-2",
                                  attrs: {
                                    color: _vm.$vuetify.theme.dark
                                      ? "white"
                                      : "secondary darken-1",
                                    rounded: "",
                                    outlined: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onSaveClick()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("login.skipSettings")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font white--text px-4 me-2",
                                  attrs: { rounded: "", color: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.e1 = 6
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("tours.buttons.next")))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-stepper-content",
                            {
                              attrs: {
                                step: "6",
                                editable: _vm.checkPassword(),
                              },
                            },
                            [
                              _c("div", { staticClass: "mb-12" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "pa-0 my-2 header-font",
                                    staticStyle: { "font-size": "22px" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("general.fieldLayout"))
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-radio-group",
                                {
                                  staticClass:
                                    "mt-2 d-flex justify-space-between",
                                  attrs: {
                                    dense: "",
                                    "hide-details": "",
                                    row: "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onFieldLayoutModelChange(
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.fieldLayoutModel,
                                    callback: function ($$v) {
                                      _vm.fieldLayoutModel = $$v
                                    },
                                    expression: "fieldLayoutModel",
                                  },
                                },
                                _vm._l(_vm.fieldLayouts, function (fl) {
                                  return _c("v-radio", {
                                    key: fl.id,
                                    staticClass: "mt-1",
                                    attrs: {
                                      color: "secondary",
                                      label: fl.name,
                                      value: fl.id,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-1 primary--text",
                                                },
                                                [_vm._v(_vm._s(fl.name))]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _vm.selectedLayout
                                ? _c(
                                    "v-row",
                                    {
                                      staticClass:
                                        "alig-center justify-center mt-4",
                                    },
                                    [
                                      _c("FieldAreaSelector", {
                                        attrs: {
                                          areas: _vm.selectedLayout.areas,
                                          fieldColor: _vm.fieldColorModel,
                                          selectable: false,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font px-4 me-2",
                                  attrs: {
                                    color: _vm.$vuetify.theme.dark
                                      ? "white"
                                      : "secondary darken-1",
                                    rounded: "",
                                    outlined: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onSaveClick()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("login.skipSettings")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font white--text px-4 me-2",
                                  attrs: { rounded: "", color: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.e1 = 7
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("tours.buttons.next")))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-stepper-content",
                            {
                              attrs: {
                                step: "7",
                                editable: _vm.checkPassword(),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "mb-12" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "body-1 font-weight-bold primary--text pb-1 mb-0",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("settings.currency"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      items: _vm.currencies,
                                      "item-text": "name",
                                      "item-value": "code",
                                      "menu-props": "auto",
                                      "hide-details": "",
                                      rules: _vm.currencyRules,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.changeCurrency(
                                          _vm.user.currency
                                        )
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function ({ item }) {
                                            return [
                                              _c("DriblabCountryFlag", {
                                                attrs: {
                                                  iso: item.countryCode,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "ml-1" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t(item.name))
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item",
                                          fn: function (data) {
                                            return [
                                              _c("DriblabCountryFlag", {
                                                attrs: {
                                                  iso: data.item.countryCode,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "ml-1" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(data.item.name)
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1374864447
                                    ),
                                    model: {
                                      value: _vm.user.currency,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.user, "currency", $$v)
                                      },
                                      expression: "user.currency",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font px-4 me-2",
                                  attrs: {
                                    color: _vm.$vuetify.theme.dark
                                      ? "white"
                                      : "secondary darken-1",
                                    rounded: "",
                                    outlined: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onSaveClick()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("login.skipSettings")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font white--text px-4 me-2",
                                  attrs: { rounded: "", color: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.e1 = 8
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("tours.buttons.next")))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-stepper-content",
                            {
                              attrs: {
                                step: "8",
                                editable: _vm.checkPassword(),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "mb-8 d-flex justify-center" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "header-font me-5",
                                      staticStyle: { "font-size": "22px" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("settings.darkMode"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-switch", {
                                    staticClass:
                                      "d-flex align-center ma-0 pa-0",
                                    attrs: {
                                      inset: "",
                                      label: "",
                                      "hide-details": "",
                                      dense: "",
                                      color: "secondary",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onDarkModeChange()
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "prepend",
                                          fn: function () {
                                            return [
                                              _c(
                                                "v-icon",
                                                { attrs: { small: "" } },
                                                [_vm._v("wb_sunny")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: { small: "" },
                                                },
                                                [_vm._v("nights_stay")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      3536540366
                                    ),
                                    model: {
                                      value: _vm.darkMode,
                                      callback: function ($$v) {
                                        _vm.darkMode = $$v
                                      },
                                      expression: "darkMode",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font px-4 me-2",
                                  attrs: {
                                    color: _vm.$vuetify.theme.dark
                                      ? "white"
                                      : "secondary darken-1",
                                    rounded: "",
                                    outlined: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onCancelClick()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("general.cancel")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font white--text px-4 me-2",
                                  attrs: { rounded: "", color: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onSaveClick()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("general.save")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }